import React from 'react';
import { PARTNER_TOKEN_OPTIONS } from './GrantTokenModal';
import { PartnerTokenTier } from '../../services/insurerService';
import { usePartnerTokenTiers } from '../../contexts/PartnerTokenTiersContext';

export function formatTokenOptionLabel(title: string, description: string): string {
  return description ? `${title} — ${description}` : title;
}

interface TokenTierSelectProps {
  id?: string;
  value: PartnerTokenTier;
  onChange: (tier: PartnerTokenTier) => void;
  disabled?: boolean;
  className?: string;
  showDescription?: boolean;
  compact?: boolean;
}

const TokenTierSelect: React.FC<TokenTierSelectProps> = ({
  id,
  value,
  onChange,
  disabled = false,
  className = 'w-full border border-gray-300 rounded-md px-3 py-2 text-sm bg-white disabled:opacity-50',
  showDescription = true,
  compact = false,
}) => {
  const { tokenOptions } = usePartnerTokenTiers();
  const options = tokenOptions.length > 0 ? (tokenOptions as typeof PARTNER_TOKEN_OPTIONS) : PARTNER_TOKEN_OPTIONS;
  const selected = options.find((option) => option.tier === value);
  const descriptionVisible = showDescription && !compact;

  return (
    <div>
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value as PartnerTokenTier)}
        disabled={disabled}
        className={className}
      >
        {options.map((option) => (
          <option key={option.tier} value={option.tier}>
            {formatTokenOptionLabel(option.title, option.description)}
          </option>
        ))}
      </select>
      {descriptionVisible && selected && (
        <p className="mt-2 text-xs text-gray-500 leading-relaxed">{selected.description}</p>
      )}
    </div>
  );
};

export default TokenTierSelect;
